import Cookies from 'js-cookie';

function getHostName(url)
{
    if (typeof URL !== 'undefined') {
        return (new URL(url)).hostname;
    }

    const matches = url.match(new RegExp('://([^/:]+)'));

    if (matches) {
        return matches[1];
    }

    return null;
}

function getUtmParameters()
{
    const utmParams = {};

    const query = decodeURIComponent(window.location.search.substring(1));
    const queryVars = query.split('&');
    let pair;

    for (let i = 0; i < queryVars.length; i++) {
        pair = queryVars[i].split('=');

        if (pair[0].match(/^utm_/)) {
            utmParams[pair[0]] = pair[1];
        }
    }

    return utmParams;
}

const referrer = document.referrer;

if (referrer) {
    const referrerHost = getHostName(referrer);

    if (referrerHost !== window.location.hostname) {
        Cookies.set('referrer_host', referrerHost, { expires: 365 });
    }
}

const utmParametersJson = JSON.stringify(getUtmParameters());

if (utmParametersJson !== '{}') {
    Cookies.set('utm_params', utmParametersJson, { expires: 365 });
}
